;(function($, undefined){

    var rnn;
    rnn = window.rnn;

    function progressBar($container) {
        // this html covers both bootstrap 2 and 3
        $container.html('<div class="progress progress-striped active">' +
                        '<div class="bar progress-bar progress-bar-striped active" style="width: 100%;" role="progressbar" aria-valuenow="100"></div>' +
                        '</div>');
    }

    function getSavedData($container, $parent, callback, error) {
        $.ajax({
            dataType: 'json',
            url: rnn.site.follow.viewSearchesURL,
            success: function (data) {
                $container.find('.progress').remove();
                if (_.isFunction(callback)) {
                    callback(data);
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                $container.find('.progress').remove();
                $parent.addClass('error');
                if (_.isFunction(error)) {
                    error();
                }
            }
        });
    }

    function initContainerSavedSearch() {
        var $parent = $('.saved-search-container');
        var $container = $parent.find('.content');

        $parent.removeClass('loaded-content loaded-nocontent');
        progressBar($container);
        getSavedData($container, $parent, function (data) {
            if (data.length > 0) {
                $parent.addClass('loaded-content');
                var source = $('#hdlbars-containers-savedSearch:first').html();
                if (source) {
                    var template = Handlebars.compile(source);
                    var html = template(data);

                    $container.html(html);
                }
            } else {
                $parent.addClass('loaded-nocontent');
            }
        }, function () {
            $parent.addClass('loaded-nocontent');
        });
    }

    function initProfileSavedSearch() {
        var $fragmentEmpty = $('.savedSearchPane').find('.savedsearchEmpty');
        var $fragmentIntro = $('.savedSearchPane').find('.savedsearchIntro');
        if ($('.savedSearchPane').find('.action').length === 0 && $fragmentEmpty.is(':hidden')) {
            var $container = $('.savedSearchPane .actions');
            var $parent = $('.savedSearchPane');

            progressBar($container);
            getSavedData($container, $parent, function (data) {
                if (data.length > 0) {
                    $fragmentIntro.removeClass('hide');
                    var source = $('#hdlbars-accounts-savedSearch').html();
                    if (source) {
                        var template = Handlebars.compile(source);
                        var html = '';
                        var selectedMonth = '';

                        _.each(data, function (value, index, list) {
                            html += template(value);
                        });
                        html += '</div>';

                        // setup time stamps and delete click events
                        $container.html(html)
                                  .find('abbr.pubDate').timeago()
                                  .end()
                                  .find('.btn-delete').on('click', function (e) {
                                    e.preventDefault();
                                    deleteAccountSearch($(this));
                                  })
                                  .parent('.action-btns').siblings('.notification-settings').find('.email-notifications-btn').on('click', function (e) {
                                    e.preventDefault();
                                    saveEmailNotificationSetting($(this));
                                });
                    }
                } else {
                    // if theres no results show the fragment
                    $container.find('.progress').remove();
                    $fragmentEmpty.removeClass('hide');

                }

            }, function () {
                $fragmentEmpty.removeClass('hide');
                rnn.modules.notifications.error('There was a problem loading your saved searches, please try again.');
            });
        }
    }

    function deleteAccountSearch($search) {
        var url = $search.data('url');
        var postData = $search.data('data');

        $search.html('Deleting...');
        $.ajax({
            url: url,
            data: { 'data': postData },
            type: 'POST',
            success: function (data) {
                if (data.message.length === 0) {
                    var $btns = $search.closest('.action-btns');
                    var $getSearchTag = $btns.parent().prev('.action').children('a').data('subscription-id');

                    $('#my-profile-tab .following').find('.following-search[data-subscription-id="' + $getSearchTag + '"]').remove();

                    $btns.parent().prev('.action').remove();
                    $btns.parent().remove();

                    rnn.modules.notifications.info('<strong>Delete successful.</strong> This search has now been removed from your Saved Searches.');
                    if ($('.savedSearchPane .action').length === 0) {
                        $('.savedSearchPane .savedsearchEmpty').removeClass('hide');
                        $('.savedSearchPane .savedsearchIntro').addClass('hide');
                    }
                } else {
                    rnn.modules.notifications.error('There was a problem deleting your search, please try again');
                    $search.html('<i class="icomoon-icon icon-bin"></i>');
                }
            }
        });
    }

    function saveEmailNotificationSetting($emailBtn) {
        var url = $emailBtn.data('url');
        var emailNotifications = $emailBtn.data('email-notifications');
        var formData = '';

        emailNotifications = emailNotifications ? false : true;
        formData = 'receive_email_notifications=' + emailNotifications;

        $.ajax({
            url: url,
            data: formData,
            type: 'POST',
            success: function (response) {
                if (response.message.length === 0) {
                    if (emailNotifications) {
                        rnn.modules.notifications.info('<strong>Subscribed.</strong> You will now receive email updates relating to this search.');
                    } else {
                        rnn.modules.notifications.info('<strong>Unsubscribed.</strong> You will no longer receive email updates relating to this search.');
                    }
                    $emailBtn.toggleClass('button-default-dark').toggleClass('button-default-border');
                    $emailBtn.data('email-notifications', response.receive_email_notifications);
                } else {
                    rnn.modules.notifications.error('There was a problem updating your email notification settings, please refresh and try again');
                }
            }
        });
    }

    function initSavedSearch() {
        if ($('.user-profile-body').length) {
            $('.savedsearchBtn').on('click', function () {
                initProfileSavedSearch();
            });
        }

        if ($('#my-account-container #notifications-tab').length) {
            initProfileSavedSearch();
        }

        if ($('.saved-search-container').length) {
            progressBar($('.saved-search-container .content'));
            rnn.modules.user.get(function (user) {
                if (user.authenticated) {
                    initContainerSavedSearch();
                } else {
                    $('.saved-search-container')
                        .addClass('logged-out')
                        .find('.progress')
                        .remove();
                }
            });
        }
    }

    rnn.modules.register('savedsearch', {
        init: initSavedSearch,
        initContainers: initContainerSavedSearch
    });

})(jQuery);
